import { useTranslation } from 'react-i18next'

interface RunReportStepIndicatorProps {
  current: number
  total: number
  format?: 'compact' | 'verbose'
}

export const RunReportStepIndicator = ({
  current,
  total,
  format = 'compact',
}: RunReportStepIndicatorProps) => {
  const { t } = useTranslation()

  if (format === 'verbose') {
    return (
      <p className="text-xl font-medium text-neutralColor60">
        {t('dashboard.runReport.consentRequired.stepperVerbose', {
          current,
          total,
        })}
      </p>
    )
  }

  return (
    <p className="text-xl font-medium text-neutralColor60">
      {current}/{total}
    </p>
  )
}
